/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';

import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import { groupBy } from 'lodash';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';

import { tableHead } from './tableHead';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import { viewPortHeight_355 } from '../../../SharedModules/CommonConstants/commonConstants';
import {
  convertStringDate,
  quarterToDate,
} from '../../../SharedModules/utilities/dateUtilities';

const DisplayPaymentSummary = () => {
  const {
    displayObj: {
      rebateProgramName: getRebateProgramName,
      rebateProgram,
      quarterFrom: getQuarterFrom,
      quarterTo: getQuarterTo,
      QuarterOption: getReportOption,
      selectedOption: getTimePeriod,
      selectedYear: getSelectedYear,
      beginDate,
      federalBeginDateDRAMS,
      stateBeginDateDRAMS,
      paymentSummary: getPaymentSummaryListData,
    },
  } = useSelector(
    (state) => state?.sharedState?.PaymentSummaryReducer // drams and all
  );

  // TO get the complete name of the rebate program
  // let rebateProgramNameValue =
  //   rebateProgramList.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${rebateProgramNameValue?.rebateProgramCd} - ${
  //   rebateProgramNameValue?.shortDescr || ''
  // }`;

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [filteredRows, setFilteredRow] = React.useState([]);

  const [paymentSummary, setPaymentSummary] = React.useState([]);

  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // Business Logic
  // const transformData = (rawData) => {
  //   const data = rawData.map((item) => {
  //     return {
  //       ...item,
  //       cc_qtr_ranget: `${moment(item.cc_begin).format('MM/DD/YYYY')}-${moment(
  //         item.cc_end
  //       ).format('MM/DD/YYYY')}`,
  //     };
  //   });

  //   const groupedData = groupBy(data, 'cc_qtr_ranget');
  //   const updatedData = [];
  //   for (const key in groupedData) {
  //     const oneRangeData = groupedData[key];
  //     let oneRow = {};
  //     for (let i = 0; i < oneRangeData.length; i++) {
  //       if (i === 0) {
  //         oneRow = oneRangeData[i];
  //       } else {
  //         oneRow.principal_paid_amt += oneRangeData[i].principal_paid_amt;
  //         oneRow.interest_paid_amt += oneRangeData[i].interest_paid_amt;
  //       }
  //     }

  //     if (Object.keys(oneRow).length > 0) {
  //       oneRow.principal_paid_amt = parseFloat(
  //         oneRow.principal_paid_amt?.toFixed(2)
  //       );
  //       oneRow.interest_paid_amt += parseFloat(
  //         oneRow.interest_paid_amt?.toFixed(2)
  //       );
  //       updatedData.push(oneRow);
  //     }
  //   }

  //   return updatedData;
  // };

  React.useEffect(() => {
    const data = getPaymentSummaryListData?.data || [];
    const newData = data?.map((item) => {
      const rebate_principal_paid_amt =
        item.dispute_resolution_cd === 'N' ? item.principal_paid_amt : '0.00';
      const rebate_interest_paid_amt =
        item.dispute_resolution_cd === 'N' ? item.interest_paid_amt : '0.00';
      const rebate_total =
        Number(rebate_principal_paid_amt) + Number(rebate_interest_paid_amt);
      const dispute_principal_paid_amt =
        item.dispute_resolution_cd === 'B' ? item.principal_paid_amt : '0.00';
      const dispute_interest_paid_amt =
        item.dispute_resolution_cd === 'B' ? item.interest_paid_amt : '0.00';
      const dispute_total =
        Number(dispute_principal_paid_amt) + Number(dispute_interest_paid_amt);
      const combined_total = item.principal_paid_amt + item.interest_paid_amt;
      const total_principal =
        Number(rebate_principal_paid_amt) +
        Number(dispute_principal_paid_amt) +
        Number(item.principal_paid_amt);
      const total_interest =
        Number(rebate_interest_paid_amt) +
        Number(dispute_interest_paid_amt) +
        Number(item.interest_paid_amt);
      const total =
        Number(rebate_total) + Number(dispute_total) + Number(combined_total);

      return {
        ...item,
        rebate_principal_paid_amt,
        rebate_interest_paid_amt,
        rebate_total,
        dispute_principal_paid_amt,
        dispute_interest_paid_amt,
        dispute_total,
        combined_total,
        total_principal,
        total_interest,
        total,
      };
    });
    const cpyData = [...data];
    const updatedKey = cpyData.map((item) => {
      return {
        ...item,
        range: `${moment.utc(item.cc_begin).format('MM/DD/YYYY')}-${moment
          .utc(item.cc_end)
          .format('MM/DD/YYYY')}`,
      };
    });
    const groupedData = Object.groupBy(updatedKey, ({ range }) => range);
    const rowkey = Object.keys(groupedData);
    let tbData = [];
    for (let i = 0; i < rowkey.length; i++) {
      const curr = groupedData[rowkey[i]];
      const rbt_data = curr.filter((o) => o.dispute_resolution_cd === 'N');
      const disp_data = curr.filter((o) => o.dispute_resolution_cd === 'Y');
      const comb_data = curr.filter((o) => o.dispute_resolution_cd === 'B');
      const rbt_prin = rbt_data
        .map((o) => o.principal_paid_amt)
        .reduce((acc, val) => acc + val, 0);
      const rbt_int = rbt_data
        .map((o) => o.interest_paid_amt)
        .reduce((acc, val) => acc + val, 0);
      const rbt_tot = rbt_prin + rbt_int;
      const disp_prin = disp_data
        .map((o) => o.principal_paid_amt)
        .reduce((acc, val) => acc + val, 0);
      const disp_int = disp_data
        .map((o) => o.interest_paid_amt)
        .reduce((acc, val) => acc + val, 0);
      const disp_tot = disp_prin + disp_int;
      const comb_prin = comb_data
        .map((o) => o.principal_paid_amt)
        .reduce((acc, val) => acc + val, 0);
      const comb_int = comb_data
        .map((o) => o.interest_paid_amt)
        .reduce((acc, val) => acc + val, 0);
      const comb_tot = comb_prin + comb_int;
      const rowdata = {
        abc: rowkey[i],
        total_principal: rbt_prin + disp_prin + comb_prin,
        total_interest: rbt_int + disp_int + comb_int,
        total: rbt_tot + disp_tot + comb_tot,
        rebate_principal_paid_amt: rbt_prin,
        rebate_interest_paid_amt: rbt_int,
        rebate_total: rbt_tot,
        dispute_principal_paid_amt: disp_prin,
        dispute_interest_paid_amt: disp_int,
        dispute_total: disp_tot,
        principal_paid_amt: comb_prin,
        interest_paid_amt: comb_int,
        combined_total: comb_tot,
      };
      tbData.push(rowdata);
    }
    // const updatedRowData = transformData(newData);
    setPaymentSummary(tbData);
  }, [getPaymentSummaryListData]);

  // pinned row
  const [filterApply, setFilterApply] = React.useState(false);

  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : paymentSummary;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data?.toFixed(2)) : '0.00';
  };
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        abc: 'Total',
        total_principal: sum('total_principal'),
        total_interest: sum('total_interest'),
        total: sum('total'),
        rebate_principal_paid_amt: sum('rebate_principal_paid_amt'),
        rebate_interest_paid_amt: sum('rebate_interest_paid_amt'),
        rebate_total: sum('rebate_total'),
        dispute_principal_paid_amt: sum('dispute_principal_paid_amt'),
        dispute_interest_paid_amt: sum('dispute_interest_paid_amt'),
        dispute_total: sum('dispute_total'),
        principal_paid_amt: sum('principal_paid_amt'),
        interest_paid_amt: sum('interest_paid_amt'),
        combined_total: sum('combined_total'),
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [paymentSummary, filteredRows]);
  // filter total
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return { ...item };
    });
    setFilteredRow(updatedRowData);
  };
  function getCurrentDate() {
    const currentDate = new Date();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const year = currentDate.getFullYear();

    return `${month}/${day}/${year}`;
  }

  const currentDate1 = getCurrentDate();

  let fromDate = '';
  let toDate = '';

  if (getTimePeriod == 'Payment Date Range') {
    fromDate = getQuarterFrom;
    toDate = getQuarterTo == '' ? fromDate : getQuarterTo;
    if (getQuarterFrom.includes('Q')) {
      fromDate = convertStringDate(quarterToDate(getQuarterFrom, 'fromDate'));
    }
    if (getQuarterTo.includes('Q')) {
      toDate = convertStringDate(quarterToDate(getQuarterTo, 'toDate'));
    }
    if (getQuarterFrom.includes('Q') && getQuarterTo === '') {
      toDate = convertStringDate(quarterToDate(getQuarterFrom, 'toDate'));
    }
  } else if (
    getTimePeriod == 'Quarter' &&
    getReportOption == 'DRAMS Invoice Start Quarter'
  ) {
    fromDate = beginDate;
    toDate = currentDate1;
  } else if (getTimePeriod == 'Quarter' && getReportOption == 'All') {
    fromDate = '01/01/1991';
    toDate = currentDate1;
  } else if (
    getTimePeriod == 'Year' &&
    getSelectedYear == 'Calender' &&
    getReportOption == 'DRAMS Invoice Start Quarter'
  ) {
    fromDate = beginDate;
    toDate = currentDate1;
  } else if (
    getTimePeriod == 'Year' &&
    getSelectedYear == 'Calender' &&
    getReportOption == 'All'
  ) {
    fromDate = '01/01/1991';
    toDate = currentDate1;
  } else if (
    getTimePeriod == 'Year' &&
    getSelectedYear == 'Federal Fiscal' &&
    getReportOption == 'DRAMS Invoice Start Quarter'
  ) {
    fromDate = beginDate || federalBeginDateDRAMS;
    toDate = currentDate1;
  } else if (
    getTimePeriod == 'Year' &&
    getSelectedYear == 'Federal Fiscal' &&
    getReportOption == 'All'
  ) {
    fromDate = '10/01/1991';
    toDate = currentDate1;
  } else if (
    getTimePeriod == 'Year' &&
    getSelectedYear == 'State Fiscal' &&
    getReportOption == 'DRAMS Invoice Start Quarter'
  ) {
    fromDate = beginDate || stateBeginDateDRAMS;
    toDate = currentDate1;
  } else {
    fromDate = '01/01/1991';
    toDate = currentDate1;
  }

  // pdf header
  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';
  let fourthInfo = '';
  firstInfo =
    getTimePeriod == 'Year'
      ? `Time Period : ${getSelectedYear}`
      : `Time Period :${getTimePeriod}`;
  secondInfo = `Date Range: ${`${fromDate}-${toDate}`}`;
  thirdInfo = `${`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}`;
  fourthInfo = `Report Option : ${getReportOption}`;

  return (
    <>
      <div className="tBillPanel custom-check tabs-container">
        <CustomSeparator
          parent1="Summary Reports"
          parent2="Display Payment Summary"
        />
        <Spinner load={spinnerLoader} />
        {!fullScreenView && (
          <>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-10">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-10 mb-3">
                      <TextField
                        id="Time_Period"
                        label="Time Period"
                        fullWidth
                        inputProps={{ id: 'Time_Period' }}
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          getTimePeriod == 'Year'
                            ? getSelectedYear
                            : getTimePeriod
                        }
                        disabled
                      />
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Report_Option"
                        label="Report Option"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          getTimePeriod == 'Payment Date Range'
                            ? 'None'
                            : getReportOption
                        }
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Date_Range"
                        label="Date Range"
                        fullWidth
                        inputProps={{ id: 'Date_Range' }}
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${fromDate}-${toDate}`}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div
          id="testGrid"
          className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
        >
          <TableGrid
            ref={gridRef}
            data-testid="payment-summary"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            isScrollOn
            defaultColWidth={120}
            rowData={paymentSummary?.map((item) => {
              return {
                ...item,
                // abc: `${moment.utc(item.cc_begin).format('MM/DD/YYYY')}-${moment
                //   .utc(item.cc_end)
                //   .format('MM/DD/YYYY')}`,
                total_principal: item.total_principal
                  ? parseFloat(item.total_principal)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                total_interest: item.total_interest
                  ? parseFloat(item.total_interest)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                total: item.total
                  ? parseFloat(item.total)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                rebate_principal_paid_amt: item.rebate_principal_paid_amt
                  ? parseFloat(item.rebate_principal_paid_amt)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                rebate_interest_paid_amt: item.rebate_interest_paid_amt
                  ? parseFloat(item.rebate_interest_paid_amt)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                rebate_total: item.rebate_total
                  ? parseFloat(item.rebate_total)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                dispute_principal_paid_amt: item.dispute_principal_paid_amt
                  ? parseFloat(item.dispute_principal_paid_amt)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                dispute_interest_paid_amt: item.dispute_interest_paid_amt
                  ? parseFloat(item.dispute_interest_paid_amt)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                dispute_total: item.dispute_total
                  ? parseFloat(item.dispute_total)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                principal_paid_amt: item.principal_paid_amt
                  ? parseFloat(item.principal_paid_amt)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                interest_paid_amt: item.interest_paid_amt
                  ? parseFloat(item.interest_paid_amt)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
                combined_total: item.combined_total
                  ? parseFloat(item.combined_total)?.toFixed(2)
                  : parseFloat(0)?.toFixed(2),
              };
            })}
            columnDefs={tableHead}
            exportFile
            animateRows
            sideBar={false}
            fileName="PaymentSummary"
            reportName="Payment Summary Report"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
            pinnedBottomRowData={pinnedBottomRowData}
            info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
          />
        </div>
      </div>
    </>
  );
};

export default DisplayPaymentSummary;
